import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { getBaseURL } from "../../services/api";
import { ToastProvider, useToast } from "./AdminToast";
import { S, COLORS, GLOBAL_ADMIN_CSS } from "./adminStyles";
import { parseMatchTime } from "../../utils/dateUtils";

const API_URL = getBaseURL();

const CompletedMatchesInner = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("adminToken");
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (!token) navigate("/winrox11-super-admin");
    else fetchCompletedMatches();
  }, [token, navigate]);

  const fetchCompletedMatches = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/admin/matches/completed`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMatches(res.data || []);
    } catch (err) {
      toast.error("Failed to load completed matches.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMatch = async (matchId, t1, t2) => {
    if (!window.confirm(`⚠️ Delete ${t1} vs ${t2}? This will delete all related data.`)) return;
    try {
      await axios.delete(`${API_URL}/admin/matches/${matchId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Match deleted.");
      fetchCompletedMatches();
    } catch (err) {
      toast.error("Failed to delete match.");
    }
  };

  return (
    <div style={S.page}>
      <style>{GLOBAL_ADMIN_CSS}</style>
      <button onClick={() => navigate("/winrox11-super-admin/dashboard")} style={S.backBtn}>← Back to Dashboard</button>

      <div style={S.topBar}>
        <div>
          <div style={S.pageTitle}>🏁 Completed Matches</div>
          <div style={S.pageSubtitle}>Archive of all past matches and results</div>
        </div>
        <div style={{ background: COLORS.card, border: `1px solid ${COLORS.cardBorder}`, borderRadius: "12px", padding: "12px 18px", textAlign: "center" }}>
          <div style={{ fontSize: "22px", fontWeight: 800, color: COLORS.indigo }}>{matches.length}</div>
          <div style={{ fontSize: "10px", color: COLORS.textMuted, fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>Completed</div>
        </div>
      </div>

      {loading ? (
        <div style={S.loading}>Loading match history...</div>
      ) : matches.length === 0 ? (
        <div style={S.empty}>No completed matches found in the archive.</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "16px" }}>
          {matches.map(m => (
            <div
              key={m.match_id}
              style={{
                background: COLORS.card,
                border: `1px solid ${COLORS.cardBorder}`,
                borderRadius: "16px",
                padding: "20px",
                position: "relative",
              }}
              className="admin-card-hover"
            >
              <div style={{ position: "absolute", top: "12px", right: "12px" }}>
                <button 
                  style={{ ...S.miniBtn, color: COLORS.red }} 
                  onClick={() => handleDeleteMatch(m.match_id, m.team1, m.team2)}
                  title="Delete Archive"
                >
                  🗑️
                </button>
              </div>

              <div style={{ marginBottom: "12px" }}>
                <span style={S.badge(COLORS.textMuted)}>COMPLETED</span>
                <span style={{ ...S.badge(COLORS.indigo), marginLeft: "8px" }}>{m.format || "T20"}</span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "20px", fontWeight: 800, color: COLORS.text }}>{m.team1}</div>
                  <div style={{ fontSize: "10px", color: COLORS.textMuted }}>TEAM A</div>
                </div>
                <div style={{ fontSize: "12px", color: COLORS.textDim, fontWeight: 700, fontStyle: "italic" }}>VS</div>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "20px", fontWeight: 800, color: COLORS.text }}>{m.team2}</div>
                  <div style={{ fontSize: "10px", color: COLORS.textMuted }}>TEAM B</div>
                </div>
              </div>

              <div style={{ fontSize: "11px", color: COLORS.textMuted, textAlign: "center", marginBottom: "16px" }}>
                📅 {parseMatchTime(m).toLocaleDateString("en-IN", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
              </div>

              <Link
                to={`/winrox11-super-admin/match/${m.match_id}`}
                style={{
                  display: "block",
                  padding: "10px",
                  background: COLORS.indigo + "15",
                  border: `1px solid ${COLORS.indigo}30`,
                  borderRadius: "10px",
                  color: COLORS.indigoLight,
                  fontWeight: 700,
                  fontSize: "11px",
                  textDecoration: "none",
                  textAlign: "center",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                📊 View Full Results
              </Link>
            </div>
          ))}
        </div>
      )}
      
      <div style={{ marginTop: "24px", padding: "16px", background: COLORS.indigo + "10", border: `1px solid ${COLORS.indigo}20`, borderRadius: "12px", fontSize: "12px", color: COLORS.textMuted, textAlign: "center" }}>
        🏆 Matches are moved to this archive every day at <strong>01:00 AM</strong>.
      </div>
    </div>
  );
};

const CompletedMatches = () => (
  <ToastProvider>
    <CompletedMatchesInner />
  </ToastProvider>
);

export default CompletedMatches;
